module.exports = __webpack_public_path__ + "static/media/Gear.57f43d24.png";